import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "special-stat-wrapper"
}
const _hoisted_2 = ["onMouseover"]
const _hoisted_3 = { class: "special-stat-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "special-container",
    title: "SPECIAL",
    "show-info": ['Default', 'SPECIAL']
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.SPECIAL), (stat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: stat,
          class: "panel-row"
        }, [
          (stat !== 'PL')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "special-stat-name",
                  onMouseover: ($event: any) => (_ctx.showInfo('SPECIAL', stat))
                }, _toDisplayString(_ctx.SPECIAL[stat].name), 41, _hoisted_2),
                _createElementVNode("div", {
                  class: _normalizeClass(["special-stat-desc", _ctx.getStatData(stat).color])
                }, _toDisplayString(_ctx.getStatData(stat).desc), 3),
                _createVNode(_component_GenericButton, {
                  "is-disabled": _ctx.getStatData(stat).value === 1,
                  variant: "minus",
                  width: "26px",
                  height: "26px",
                  text: "-",
                  onClick: ($event: any) => (_ctx.modifySPECIAL('-', stat))
                }, null, 8, ["is-disabled", "onClick"]),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getStatData(stat).value), 1),
                _createVNode(_component_GenericButton, {
                  "is-disabled": _ctx.getStatData(stat).value === 10 || _ctx.state.build.SPECIAL.PL.value === 0,
                  variant: "plus",
                  width: "26px",
                  height: "26px",
                  text: "+",
                  onClick: ($event: any) => (_ctx.modifySPECIAL('+', stat))
                }, null, 8, ["is-disabled", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }))
}